import { getCurrentInstance as getVM, computed } from '@vue/composition-api';

/**
 * Return the proxy of the current vue instance
 * source: https://github.com/nuxt-community/composition-api/blob/main/src/composables/utils.ts
 */
export const getCurrentInstance = () => {
  const vm = getVM();
  if (!vm) return;
  return vm.proxy;
};

/**
 * You might want to create a custom helper to 'convert' a non-Composition API property to a Composition-ready one. `wrapProperty` enables you to do that easily, returning either a computed or a bare property as required.
 * @param property the name of the property you would like to access. For example, `$store` to access `this.$store`.
 * @param makeComputed a boolean indicating whether the helper function should return a computed property or not. Defaults to `true`.
 * source: https://github.com/nuxt-community/composition-api/blob/main/src/composables/wrappers.ts
 */
export const wrapProperty = (property, makeComputed = true) => {
  const vm = getCurrentInstance();
  if (!vm) throw new Error('This must be called within a setup function.');
  const prop = makeComputed === true ? computed(() => vm[property]) : vm[property];
  return prop;
};
